import { createRouter } from "@/helpers/routerHelper";

import Stammdaten from "./views/Stammdaten.vue";
import Charakteristik from "./views/Charakteristik.vue";
import Hydrologie from "./views/Hydrologie.vue";
import Download from "./views/Download.vue";

export default createRouter("/seenatlas", [
  {
    path: "/:id",
    redirect: "/:id/stammdaten",
    props: true
  },
  {
    path: "/:id/stammdaten",
    name: "Stammdaten",
    component: Stammdaten,
    props: true
  },
  {
    path: "/:id/charakteristik",
    name: "Charakteristik",
    component: Charakteristik,
    props: true
  },
  {
    path: "/:id/hydrologie",
    name: "Hydrologie",
    component: Hydrologie,
    props: true
  },
  {
    path: "/:id/download",
    name: "Download",
    component: Download,
    props: true
  }
]);
